import { render, staticRenderFns } from "./bear_dialog.vue?vue&type=template&id=b7d48562&scoped=true"
import script from "./bear_dialog.vue?vue&type=script&lang=js"
export * from "./bear_dialog.vue?vue&type=script&lang=js"
import style0 from "./bear_dialog.vue?vue&type=style&index=0&id=b7d48562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_css-loader@6.11.0_webpack@5.109.2_clean-css_b66c2628a85b517bb8b270c746a8724b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d48562",
  null
  
)

export default component.exports